// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","293":"component---src-pages-index-js","731":"component---src-pages-endpoints-js"}[chunkId] || chunkId) + "-" + {"223":"03c76851b29aa33b7b8e","293":"96e4fe4633196257cc25","452":"4d46ac205451834ccd63","522":"fc5d010a3a06f687197d","551":"94e4194eadcbe2e94dae","731":"c9c842a5e01171271039"}[chunkId] + ".js";
};